import type { MeetingPlatform } from 'src/meetings/models';
import GoogleMailSmall from '../assets/platforms/small/googlemail.svg';
import GoogleMeetSmall from '../assets/platforms/small/googlemeet.svg';
import ZoomSmall from '../assets/platforms/small/zoom.svg';
import TeamsSmall from '../assets/platforms/small/teams.svg';

type Props = {
  platform: MeetingPlatform;
  size?: number;
};

const platformIcons: Partial<Record<MeetingPlatform, string>> = {
  GOOGLE_MEET: GoogleMeetSmall,
  GOOGLE_MEET_MEDIA_API: GoogleMeetSmall,
  ZOOM: ZoomSmall,
  ZOOM_RTMS: ZoomSmall,
  MICROSOFT_TEAMS: TeamsSmall,
  MICROSOFT_TEAMS_LIVE: TeamsSmall,
  // Missing assets:
  // GOTO_MEETING: GoogleMailSmall,
  // WEBEX: GoogleMailSmall,
  // CHIME_SDK: GoogleMailSmall,
  // WEBRTC: GoogleMailSmall,
  // SLACK_AUTHENTICATOR: GoogleMailSmall,
  // SLACK_HUDDLE_OBSERVER: GoogleMailSmall,
};

export const MeetingPlatformIcon = ({ platform, size = 16 }: Props) => {
  const icon = platformIcons[platform] || GoogleMailSmall;
  return <img src={icon} alt={platform} width={size} height={size} />;
};
